import { useState } from 'react';
import { Send } from 'lucide-react';
import { connect } from 'react-redux';
import { ConversationActions } from 'store/actions';
import toast from 'react-hot-toast';

let enhancer = connect(null, { ...ConversationActions });

const isConversationClosedError = (error) =>
  String(error?.errors || error?.message || error || '').toLowerCase().includes('cannot send a message to a closed conversation');

function ReplyBox({ conversationId, onSent, onClosed, createMessage }) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  let disabled = !message.trim() || sending

  const handleSend = async () => {
    if (disabled) return;

    setSending(true)
    try {
      const { data } = await createMessage(conversationId, { message: { content: message.trim() } })
      setMessage('')
      onSent(data)
    } catch (error: any) {
      if (isConversationClosedError(error)) onClosed()

      toast.error(error.errors || 'Failed to send message')
    }
    setSending(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend()
    }
  }

  return (
    <div className="shrink-0 border-t border-base-200 bg-base-100 px-4 py-3">
      <div className="flex items-end gap-2">
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Message..."
          rows={1}
          className="min-h-11 max-h-32 flex-1 resize-none overflow-y-auto rounded-2xl border border-base-300 bg-base-100 px-4 py-2.5 text-sm leading-relaxed text-secondary-900 outline-none transition-colors [field-sizing:content] placeholder:text-secondary-400 focus:border-teamcare-blue/40 focus:ring-2 focus:ring-teamcare-blue/10"
        />
        <button
          onClick={handleSend}
          disabled={disabled}
          aria-label="Send message"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-teamcare-blue text-white shadow-sm shadow-blue-200/60 transition-colors hover:bg-teamcare-blue-dark disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-secondary-400 disabled:shadow-none"
        >
          {sending
            ? <span className="loading loading-spinner loading-xs" />
            : <Send size={18} strokeWidth={2.5} />
          }
        </button>
      </div>
    </div>
  );
}

export default enhancer(ReplyBox);
